"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLotteries = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var currencies_1 = require("../currencies");
var next_intl_1 = require("next-intl");
var useLotteries = function () {
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.GET_LOTTERIES,
        payload: { currency: currentCurrency, lang: lang },
        revalidateOnMount: true,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading, isValidating = _a.isValidating;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    };
};
exports.useLotteries = useLotteries;
